module.exports = __webpack_public_path__ + "static/img/error.d44fdc0d.png";